// extracted by mini-css-extract-plugin
export default {"blackToast":"Toast_blackToast__CTX1g"};